// extracted by mini-css-extract-plugin
export default {"OrderDetails":"OrderDetails-styles__OrderDetails__xd5bR"};